import React from "react";

// styles
import * as Styled from './styles'
import * as SharedStyled from '../styles'
// libs
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import { faGlobe } from '@fortawesome/free-solid-svg-icons'

function Header({ logo }) {
    return (
        <Styled.Footer>
            <SharedStyled.Logo>
                { logo }
            </SharedStyled.Logo>

            <h3>Find us</h3>
            <ul>
                <li>
                    <a href="https://www.instagram.com/react_labs/">
                        <FontAwesomeIcon icon={ faInstagram } />
                        react_labs
                    </a>
                </li>
                <li>
                    <a href="https://caruaru.upe.br/react/">
                        <FontAwesomeIcon icon={ faGlobe } />
                        caruaru.upe.br/react
                    </a>
                </li>
            </ul>
        </Styled.Footer>
    );
}

export default Header;
